import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './pages/Header';
import Hero from './pages/hero';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import OurExpertise from './pages/WhyNimble';
import OurResponsibilities from './pages/OurResponsibilities';
import Business from './pages/Business';
import AromaticChemicals from './pages/AromaticChemicals';
import HeatDissipation from './pages/HeatDissipation';
import EcoFriendlySolutions from './pages/EcoFriendlySolutions';
import GreenMetalWorking from './pages/GreenMetalWorking';
import EHSSustainability from './pages/EHSSustainability';
import './App.css';

// ScrollToTop component to handle scroll restoration
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Create a wrapper component to handle route changes
function AppRoutes() {
  const location = useLocation();
  
  return (
    <Routes key={location.pathname}>
      <Route path="/" element={<Hero />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/expertise" element={<OurExpertise />} />
      <Route path="/responsibilities" element={<OurResponsibilities />} />
      <Route path="/ehs-sustainability" element={<EHSSustainability />} />
      <Route path="/business" element={<Business />} />
      <Route path="/business/aromatic-chemicals" element={<AromaticChemicals />} />
      <Route path="/business/heat-dissipation" element={<HeatDissipation />} />
      <Route path="/business/eco-friendly-solutions" element={<EcoFriendlySolutions />} />
      <Route path="/business/green-metal-working" element={<GreenMetalWorking />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App; 